import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IModelDetailParams, IModelDetailResponse, IModelDetailState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchUpdateModelDetail = createAsyncThunk(
  'listModelDetails/fetchUpdateModelDetail',
  async ({ id, params }: { id: string; params: IModelDetailParams }, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.updateModelDetail(id, params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IModelDetailState = {
  isLoading: false,
  response: null,
  error: null
}

const updateModelDetailSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetUpdateModelDetail: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchUpdateModelDetail.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchUpdateModelDetail.fulfilled, (state, action: PayloadAction<IModelDetailResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchUpdateModelDetail.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default updateModelDetailSlice.reducer
export const { resetUpdateModelDetail } = updateModelDetailSlice.actions
